import { useThemeContext } from "../../theme/ThemeContext";
import { Theme } from "../../../constant/Theme";
import DarkOsmTileLayer from "./DarkOsmTileLayer";
import LightOsmTileLayer from "./LightOsmTileLayer";
import SatelliteOsmTileLayer from "./SatelliteOsmTileLayer";

const OsmTileLayer = () => {
  const { theme, satelliteMode } = useThemeContext();

  if (satelliteMode) {
    return <SatelliteOsmTileLayer />;
  }

  if (theme === Theme.DARK) {
    return <DarkOsmTileLayer />;
  }

  return <LightOsmTileLayer />;
};

export default OsmTileLayer;
